import React, {useEffect, useState} from "react";
import {PageHeader} from "../../../components/PageHeader";
import {WorkListType} from "./subPages/WorkListType";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getWorkList} from "../../../api/maintenance/WorkService";
import MaintenanceListThumbType from "../MaintenanceListThumbType";
import MobileCreateButton from "../../../components/buttons/MobileCreateButton";
import {CHART_REGISTRY} from "../../../components/AiComponents/ChartRegistry";

function WorkList() {
    const [checked,setChecked] = useState([]);

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { data, newData, pageInfo, dataHook} =
        useRequestData(getWorkList, initDate, "work");

    const [listType, setListType] = useState(true)
    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }
    }, []);

    return (
        <>
            <div className="common-container">
                <PageHeader header={"작업등록관리"} indicator={`유지보수업무 > 작업관리 > 작업등록관리`} keys={CHART_REGISTRY.work.key} />

                { listType ?
                    <WorkListType
                        data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook}
                        checked={{checked: checked, setChecked: setChecked}} />
                    :
                    <MaintenanceListThumbType data={data} date={initDate} pageInfo={pageInfo} dataHook={dataHook} type={"work"} />
                }

                <MobileCreateButton  url={'/maintenance/work/create'} assetCheck />
            </div>
        </>
    );
}

export {WorkList}